export const arrayToSentence = (arr: string[]) => {
  if (arr.length <= 2) {
    return arr.join(' and ');
  }

  return arr.slice(0, arr.length - 1).join(', ') + ", and " + arr.slice(-1);
};

export default arrayToSentence;
